// Real SVG flags (flag-icons, MIT) for the 15 countries named in Aurora's registration sheet (read 27 September 2026).
// The site shows these 15 plus a "+12" tile for the 27+ total; the other countries are not named.
import auRect from "flag-icons/flags/4x3/au.svg";
import auRound from "flag-icons/flags/1x1/au.svg";
import azRect from "flag-icons/flags/4x3/az.svg";
import azRound from "flag-icons/flags/1x1/az.svg";
import bgRect from "flag-icons/flags/4x3/bg.svg";
import bgRound from "flag-icons/flags/1x1/bg.svg";
import caRect from "flag-icons/flags/4x3/ca.svg";
import caRound from "flag-icons/flags/1x1/ca.svg";
import cnRect from "flag-icons/flags/4x3/cn.svg";
import cnRound from "flag-icons/flags/1x1/cn.svg";
import deRect from "flag-icons/flags/4x3/de.svg";
import deRound from "flag-icons/flags/1x1/de.svg";
import ghRect from "flag-icons/flags/4x3/gh.svg";
import ghRound from "flag-icons/flags/1x1/gh.svg";
import inRect from "flag-icons/flags/4x3/in.svg";
import inRound from "flag-icons/flags/1x1/in.svg";
import maRect from "flag-icons/flags/4x3/ma.svg";
import maRound from "flag-icons/flags/1x1/ma.svg";
import ngRect from "flag-icons/flags/4x3/ng.svg";
import ngRound from "flag-icons/flags/1x1/ng.svg";
import snRect from "flag-icons/flags/4x3/sn.svg";
import snRound from "flag-icons/flags/1x1/sn.svg";
import sgRect from "flag-icons/flags/4x3/sg.svg";
import sgRound from "flag-icons/flags/1x1/sg.svg";
import zaRect from "flag-icons/flags/4x3/za.svg";
import zaRound from "flag-icons/flags/1x1/za.svg";
import uaRect from "flag-icons/flags/4x3/ua.svg";
import uaRound from "flag-icons/flags/1x1/ua.svg";
import usRect from "flag-icons/flags/4x3/us.svg";
import usRound from "flag-icons/flags/1x1/us.svg";

export const AURORA_COUNTRIES = [
  { code: "au", name: "Australia", rect: auRect, round: auRound, lonLat: [134, -25] },
  { code: "az", name: "Azerbaijan", rect: azRect, round: azRound, lonLat: [47.5, 40.3] },
  { code: "bg", name: "Bulgaria", rect: bgRect, round: bgRound, lonLat: [25.5, 42.7] },
  { code: "ca", name: "Canada", rect: caRect, round: caRound, lonLat: [-100, 57] },
  { code: "cn", name: "China", rect: cnRect, round: cnRound, lonLat: [104, 35] },
  { code: "de", name: "Germany", rect: deRect, round: deRound, lonLat: [10.4, 51.2] },
  { code: "gh", name: "Ghana", rect: ghRect, round: ghRound, lonLat: [-1.2, 7.9] },
  { code: "in", name: "India", rect: inRect, round: inRound, lonLat: [79, 22] },
  { code: "ma", name: "Morocco", rect: maRect, round: maRound, lonLat: [-6.5, 31.8] },
  { code: "ng", name: "Nigeria", rect: ngRect, round: ngRound, lonLat: [8.7, 9.1] },
  { code: "sn", name: "Senegal", rect: snRect, round: snRound, lonLat: [-14.5, 14.5] },
  { code: "sg", name: "Singapore", rect: sgRect, round: sgRound, lonLat: [103.8, 1.35] },
  { code: "za", name: "South Africa", rect: zaRect, round: zaRound, lonLat: [24.7, -29] },
  { code: "ua", name: "Ukraine", rect: uaRect, round: uaRound, lonLat: [31.2, 48.4] },
  { code: "us", name: "United States", rect: usRect, round: usRound, lonLat: [-98, 39] },
];

export const AURORA_REPORTED_COUNTRIES = 27;

export function Flag({ code, shape = "rect", className = "", title }) {
  const country = AURORA_COUNTRIES.find((item) => item.code === code);
  if (!country) return null;
  return (
    <img
      className={`flag flag--${shape} ${className}`}
      src={shape === "round" ? country.round : country.rect}
      alt={title ?? ""}
      aria-hidden={title ? undefined : "true"}
      width={shape === "round" ? 24 : 32}
      height={24}
      loading="lazy"
      decoding="async"
    />
  );
}
